import { createFeatureSelector, createSelector } from '@ngrx/store';
import { each } from 'lodash-es';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { AccessHistory } from '../models';
import { AccessHistoryState } from '../reducers/access-history.reducer';

export const selectAccessHistoryState = createFeatureSelector<AccessHistoryState>('accessHistory');

export const selectAccessHistoryPageLoading = createSelector(
  selectAccessHistoryState,
  (state) => state.pageLoading,
);

export const selectAccessHistoryShowInitWaitingMessage = createSelector(
  selectAccessHistoryState,
  (state) => state.showInitWaitingMessage,
);

export const selectAccessHistoryError = createSelector(
  selectAccessHistoryState,
  (state) => state.error,
);

export const selectAccessHistoryPage = createSelector(selectAccessHistoryState, (state) => {
  const accessHistories: AccessHistory[] = [];
  each(state.ids, (id: number) => accessHistories.push(state.entities[id]));

  return new QueryResultsModel(accessHistories, state.totalCount);
});
